export default {
  env: 'test',
  cookie: 'md-noticejs-sticky-',
  domain: 'mdirector.com',
};



/** WEBPACK FOOTER **
 ** ./src/environments/test.js
 **/